import get from "lodash/get"
import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Input,
  CardImg,
  CardSubtitle,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap"
import { withRouter } from "react-router-dom"

import { useSelector, useDispatch } from "react-redux"

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb"
import { apiError, removeError } from "store/actions"
import FieldValidation from "../../../components/Common/FieldValidation"
import { createShop, getAllShops, updateShop } from "store/Admin/shops/actions"
import { isEmpty } from "lodash"
import { getAllAdminUsersCall } from "../../../helpers/repository"
import { checkUserHasRole, mapDataForDropDown } from "helpers/helpers"
import {sitename} from "../../../constants/constants";
const Create = props => {
  const dispatch = useDispatch()
  const [name, set_name] = useState("")
  const [address, set_address] = useState("")
  const [opening_hours, set_opening_hours] = useState("")
  const [closing_hours, set_closing_hours] = useState("")
  const [agents, set_agents] = useState("")
  const [agent_id, set_agent_id] = useState("")
  const [shop_managers, set_shop_managers] = useState({
    id: "",
    value: "",
    label: "",
  })
  const [shop_manager_id, set_shop_manager_id] = useState("")

  useEffect(() => {
    dispatch(apiError(""))
    getAllAdminUsersCall("agent").then(response => {
      set_agents(response?.data?.data)
    })
    getAllAdminUsersCall("shop-manager").then(response => {
      set_shop_managers(mapDataForDropDown(response?.data?.data))
    })
    if (checkUserHasRole("agent")) {
      set_agent_id(JSON.parse(localStorage.getItem("user"))?.user?.id)
    }
  }, [])
  const handleSubmit = e => {
    e.preventDefault()
    const data = {
      name: name,
      address: address,
      opening_hours: opening_hours,
      closing_hours: closing_hours,
      agent_id: agent_id,
      shop_manager_id: shop_manager_id,
    }

    dispatch(createShop(data, props.history))
  }

  const formErrors = useSelector(state => state?.CommonState)
  const removeError = key => {
    let e = _.cloneDeep(formErrors)
    delete e[key]
    dispatch(apiError(e))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Bonuses" breadcrumbItem="Create" />
          <Card>
            <h5 className="card-header bg-transparent border-bottom text-uppercase">
              Create Shop
            </h5>

            <CardBody>
              <Form onSubmit={handleSubmit}>
                {!checkUserHasRole("agent") && (
                  <div className="row mb-4">
                    <Label
                      htmlFor="agents_dropdown"
                      className="col-sm-3 col-form-label"
                    >
                      Agents
                    </Label>
                    <Col sm={5}>
                      <Select
                        id="agents_dropdown"
                        maxMenuHeight={150}
                        onChange={agent => {
                          removeError("agents")
                          set_agent_id(agent?.id)
                        }}
                        options={mapDataForDropDown(agents)}
                        classNamePrefix="select2-selection"
                      />
                      {formErrors?.agent_id ? (
                        <FieldValidation errorMessage={formErrors?.agent_id} />
                      ) : null}
                    </Col>
                  </div>
                )}

                <div className="row mb-4">
                  <Label
                    htmlFor="shop_manager_dropdown"
                    className="col-sm-3 col-form-label"
                  >
                    Shop Manager
                  </Label>
                  <Col sm={5}>
                    <Select
                      id="shop_manager_dropdown"
                      maxMenuHeight={150}
                      onChange={shop_manager => {
                        removeError("shop_manager")
                        set_shop_manager_id(shop_manager?.id)
                      }}
                      options={shop_managers}
                      classNamePrefix="select2-selection"
                    />
                    {formErrors?.shop_manager_id ? (
                      <FieldValidation
                        errorMessage={formErrors?.shop_manager_id}
                      />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="shop_name_input"
                    className="col-sm-3 col-form-label"
                  >
                    Name
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="text"
                      maxLength="20"
                      name="name"
                      onChange={e => {
                        removeError("name")
                        set_name(e.target.value)
                      }}
                      value={name}
                      id={"shop_name_input"}
                    />
                    {formErrors?.name ? (
                      <FieldValidation errorMessage={formErrors?.name} />
                    ) : null}
                  </Col>
                </div>
                <div className="row mb-4">
                  <Label
                    htmlFor="shop_address_input"
                    className="col-sm-3 col-form-label"
                  >
                    Address
                  </Label>
                  <Col sm={5}>
                    <Input
                      type="text"
                      name="address"
                      onChange={e => {
                        removeError("address")
                        set_address(e.target.value)
                      }}
                      value={address}
                      id={"shop_address_input"}
                    />
                    {formErrors?.address ? (
                      <FieldValidation errorMessage={formErrors?.address} />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="shop_opening_hours"
                    className="col-sm-3 col-form-label"
                  >
                    Opening Hours
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="time"
                      id="shop_opening_hours"
                      name="opening_hours"
                      value={opening_hours}
                      onChange={e => {
                        removeError("address")
                        set_opening_hours(e.target.value)
                      }}
                    />
                    {formErrors?.opening_hours ? (
                      <FieldValidation
                        errorMessage={formErrors?.opening_hours}
                      />
                    ) : null}
                  </Col>
                </div>

                <div className="row mb-4">
                  <Label
                    htmlFor="shop_closing_hours"
                    className="col-sm-3 col-form-label"
                  >
                    Closing Hours
                  </Label>
                  <Col sm={5}>
                    <input
                      className="form-control"
                      type="time"
                      id="shop_closing_hours"
                      name="closing_hours"
                      onChange={e => {
                        removeError("closing_hours")
                        set_closing_hours(e.target.value)
                      }}
                      value={closing_hours}
                    />
                    {formErrors?.closing_hours ? (
                      <FieldValidation
                        errorMessage={formErrors?.closing_hours}
                      />
                    ) : null}
                  </Col>
                </div>

                <div className="row">
                  <Col sm={3}></Col>
                  <Col sm={9}>
                    <Row>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button type="submit" color="primary" className="w-100">
                          Submit
                        </Button>
                      </Col>
                      <Col sm={4} xs={6} md={4} lg={3} xl={2}>
                        <Button
                          type="button"
                          color="secondary"
                          className="w-100"
                          onClick={() => {
                            props.history.push("/admin/shops")
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col sm={4} md={4} lg={6} xl={8}></Col>
                    </Row>
                  </Col>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
export const CreateShop = withRouter(Create)
